"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Modal", {
    enumerable: true,
    get: function() {
        return Modal;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
var _react1 = require("@headlessui/react");
var _xicon = /*#__PURE__*/ _interopRequireDefault(require("@heroicons/react/outline/XIcon"));
var _classnames = /*#__PURE__*/ _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
var Modal = function(props) {
    var show = props.show, children = props.children, onClose = props.onClose, _props_maxWidth = props.maxWidth, maxWidth = _props_maxWidth === void 0 ? "lg" : _props_maxWidth, _props_closeButton = props.closeButton, closeButton = _props_closeButton === void 0 ? true : _props_closeButton, _props_loading = props.loading, loading = _props_loading === void 0 ? false : _props_loading, _props_bgColor = props.bgColor, bgColor = _props_bgColor === void 0 ? "bg-gray-500" : _props_bgColor;
    return /*#__PURE__*/ _react.default.createElement(_react1.Transition.Root, {
        show: show,
        as: _react.Fragment
    }, /*#__PURE__*/ _react.default.createElement(_react1.Dialog, {
        as: "div",
        className: "fixed z-10 inset-0 overflow-y-auto",
        onClose: function() {
            return onClose && onClose();
        }
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: "flex items-center justify-center min-h-screen md:px-4 pb-20 text-center sm:block sm:p-0"
    }, /*#__PURE__*/ _react.default.createElement(_react1.Transition.Child, {
        as: _react.Fragment,
        enter: "ease-out duration-300",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "ease-in duration-200",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0"
    }, /*#__PURE__*/ _react.default.createElement(_react1.Dialog.Overlay, {
        className: "".concat(bgColor, " fixed inset-0  bg-opacity-75 transition-opacity")
    })), /*#__PURE__*/ _react.default.createElement("span", {
        className: "hidden sm:inline-block sm:align-middle sm:h-screen",
        "aria-hidden": "true"
    }, "​"), /*#__PURE__*/ _react.default.createElement(_react1.Transition.Child, {
        as: _react.Fragment,
        enter: "ease-out duration-300",
        enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
        enterTo: "opacity-100 translate-y-0 sm:scale-100",
        leave: "ease-in duration-200",
        leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
        leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: (0, _classnames.default)("inline-block align-bottom bg-white md:rounded-lg px-8 md:px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-full sm:p-6 rounded-none", {
            "sm:max-w-lg": maxWidth === "lg",
            "sm:max-w-sm": maxWidth === "sm",
            "sm:max-w-xs": maxWidth === "xs",
            "sm:max-w-md": maxWidth === "md"
        })
    }, closeButton && /*#__PURE__*/ _react.default.createElement("div", {
        className: "block absolute top-0 right-0 pt-4 pr-4"
    }, /*#__PURE__*/ _react.default.createElement("button", {
        type: "button",
        className: (0, _classnames.default)("bg-white rounded-md text-gray-400  focus:outline-none", {
            "hover:text-gray-500": !loading,
            "cursor-default opacity-50": loading
        }),
        onClick: function() {
            return onClose && onClose();
        },
        disabled: loading
    }, /*#__PURE__*/ _react.default.createElement("span", {
        className: "sr-only"
    }, "Close"), /*#__PURE__*/ _react.default.createElement(_xicon.default, {
        className: "h-6 w-6",
        "aria-hidden": "true"
    }))), children)))));
};

//# sourceMappingURL=Modal.js.map